module.exports = "<div [innerHTML]=\"pageConfig.PromotionFAQ | safeHtml\"></div>\r\n"